module.exports = __webpack_public_path__ + "static/media/sun.b9f17986.svg";